import { BarCodeDto } from 'src/dtos/barcode/barcodeDto';
/**
 * 바코드 관리 확장 인터페이스 (UI용)
 */
export interface MST1060_R10Dto extends BarCodeDto {
	valueIndex: number;       // 공통 유틸에서 사용하는 인덱스
	orderIndex: number;       // 정렬용 인덱스
	orderIndexSeq: number;    // 정렬 시퀀스
	
	isDeleted?: boolean;      // 삭제 여부
}

/**
 * 바코드 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultMST1060_R10Dto: MST1060_R10Dto = {
	valueIndex: -1,
	orderIndex: -1,
	orderIndexSeq: 0,

	barcode: '',
	itemCd: '',
	packQty: 0,
	itemUnit: 'EA',
	remark: '',
	
	itemNm: '',
	itemSpec: '',
	
	inserted: true,
	isModified: false,
	isDeleted: false,
};

